import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import {
  headersContratosEntregaItem,
  headersContratosEntregas,
  tableEntregaItem,
  valoresExibidosOffCanvasContratosTermoAditivo,
} from './auxiliarContratos';
import { SubAbasContratos, SubAbasContratosNovo } from './subabasContratos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomOffcanvas from '../../../../components/CustomOffcanvas';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import Modal from '../../../../components/Modal';
import ModalTwo from '../../../../components/ModalTwo';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { ProaqDestaque } from '../../../../modules/types/Proaq';
import { LogData } from '../../../../modules/types/types';
import { useNivelCriticidade } from '../../../../services/enum/useNivelCriticidade';
import theme from '../../../../theme';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import {
  fieldObjectProaq,
  valoresExibidosProaq,
} from '../../ProcessosAquisitivos/auxiliarProaq';

// Dados do usuário
//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Proaq_Destaque;

const ContratosEntregas: React.FC = () => {
  // const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  let subAbas;
  const NivelCriticidade = useNivelCriticidade();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [logData] = useState<LogData>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [destaqueId, setDestaqueId] = useState<string>('');
  const [updating, setUpdating] = useState<boolean>(false);
  const [data] = useState<any>();
  const [formDestaque, setFormDestaque] = useState<ProaqDestaque>({
    id: 0,
    descricao: '',
    nivelCriticidade: 0,
    observacoes: '',
    titulo: '',
    proaqId: parseInt(fichaID, 10),
    usuarioId: userID,
  });

  //Subabas
  if (fichaID !== 'undefined') {
    subAbas = SubAbasContratos(fichaID);
  } else {
    subAbas = SubAbasContratosNovo;
  }

  let tituloModal = '';
  if (updating) {
    tituloModal = 'Item da Pauta';
  } else {
    tituloModal = 'Item da Pauta';
  }
  const iconeModal = 'account_tree';

  //Buscar dados
  // const fetchData = async (id: string) => {
  //   try {
  //     const destaques = await getDestaquesByProaqId(id);
  //     setData(destaques);
  //   } catch (error) {
  //     console.error('Erro ao obter dados', error);
  //   }
  // };

  //Dados da tabela
  // const tableDataDestaques = data
  //   ? data.map((item: ProaqDestaque) => ({
  //       id: item.id,
  //       nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
  //       titulo: item.titulo,
  //       descricao: item.descricao,
  //     }))
  //   : [];

  //Dados do Offcanvas
  const offCanvasData = data
    ? data.map((item: any) => ({
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
        observacoes: item.observacoes,
      }))
    : [];

  const exportData = data
    ? data.map((item: any) => ({
        //Dados da entidade
        id: item.id,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
        observacoes: item.observacoes,

        //Dados do Fornecedor
        proaq: item.proaq.id,
        denominacaoGenerica:
          item.proaq.denominacaoGenerica &&
          item.proaq.denominacaoGenerica != null
            ? item.proaq.denominacaoGenerica.denominacaoGenerica
            : null,
        KitProdutoDAF:
          item.proaq.KitProdutoDAF && item.proaq.KitProdutoDAF != null
            ? item.proaq.KitProdutoDAF.nomeKit
            : null,
        //Logs
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioRegistro: formataNomeMeioSiglas(
          item.usuarioRegistro.nomeCompleto,
        ),
        usuarioAtualizacao: formataNomeMeioSiglas(
          item.usuarioAtualizacao.nomeCompleto,
        ),
        usuarioUltimaVisualizacao: formataNomeMeioSiglas(
          item.usuarioUltimaVisualizacao.nomeCompleto,
        ),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
      }))
    : [];

  //Funções Handle

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    if (name == 'nivelCriticidade') {
      setFormDestaque({
        ...formDestaque,
        nivelCriticidade: newValue,
      });
    } else {
      setFormDestaque((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearForm = () => {
    setFormDestaque({
      ...formDestaque,
      id: 0,
      descricao: '',
      nivelCriticidade: 0,
      observacoes: '',
      titulo: '',
      proaqId: parseInt(fichaID, 10),
      usuarioId: userID,
    });
  };

  const handleShowModal = () => {
    setShowModal((show) => !show);
  };

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    setDestaqueId(id);
    setUpdating(true);
    setShowModal(true);
  };

  const handleCreate = async () => {
    alert('handleCreate');
  };

  const handleUpdate = async () => {
    alert('handleUpdate');
  };

  const handleDelete = async () => {
    alert('handleDelete');
  };

  const handleRowClickEntrega = () => {
    alert('teste');
  };

  const tableEntrega = [
    {
      id: 1,
      instrumento: 'Contrato',
      numeroInstrumento: '048/25',
      parcela: '2',
      numeroPauta: '2',
      itemPauta: '5',
      produto: 'Nome do Produto Farmacêutico',
      qtdPauta: '30.000',
      qtdEntregue: '21.500',
      percentualEntregue: '71,6%',
    },
  ];

  const [showModalEntregaItem, setShowModalEntregaItem] =
    useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [logEntregaItemData, setLogEntregaItemData] = useState<LogData>();
  const handleShowModalEntregaItem = () => {
    setShowModalEntregaItem((prev) => !prev);
  };

  // const statusBin = [
  //   { value: 1, label: 'Sim' },
  //   { value: 2, label: 'Não' },
  // ];

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/contratos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <CustomOffcanvas
          title={tituloModal}
          show={showModal}
          onClose={handleShowModal}
          width="70vw"
        >
          <WorkspaceFicha>
            <Log {...logData} />
            <BoxConteudo boxTitulo="Identificação do Item da Pauta">
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol width="200px">
                  <Input
                    name="titulo"
                    value="Entregue Parcial"
                    id="titulo"
                    label="Status"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="160px">
                  <Input
                    name="titulo"
                    value="Contrato"
                    id="titulo"
                    label="Tipo de Instrumento"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="042/25"
                    id="titulo"
                    label="Nº Instrumento"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="100px">
                  <Input
                    name="titulo"
                    value="4"
                    id="titulo"
                    label="Nº Parcela"
                    onChange={handleChange}
                    readonly
                    textAlign="right"
                  />
                </CustomCol>
                <CustomCol width="100px">
                  <Input
                    name="titulo"
                    value="7"
                    id="titulo"
                    label="Nº da Pauta"
                    onChange={handleChange}
                    readonly
                    textAlign="right"
                  />
                </CustomCol>
                <CustomCol width="100px">
                  <Input
                    name="titulo"
                    value="10"
                    id="titulo"
                    label="Nº do Item"
                    onChange={handleChange}
                    readonly
                    textAlign="right"
                  />
                </CustomCol>
                <CustomCol width="100px">
                  <Input
                    name="titulo"
                    value="AC"
                    id="titulo"
                    label="UF"
                    onChange={handleChange}
                    readonly
                  />
                </CustomCol>
                <CustomCol>
                  <Select
                    name="nivelCriticidade"
                    value={formDestaque.nivelCriticidade}
                    options={NivelCriticidade}
                    onChange={handleChange}
                    label="Produto Farmacêutico"
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol width="200px">
                  <Input
                    name="titulo"
                    value="2.000.000"
                    id="titulo"
                    label="Qtd Total Item Pauta"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="200px">
                  <Input
                    name="titulo"
                    value="1.000.000"
                    id="titulo"
                    label="Qtd Total Entregue"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="110px">
                  <Input
                    name="titulo"
                    value="50,0%"
                    id="titulo"
                    label="% Entregue"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="100px"></CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="500"
                    id="titulo"
                    label="Fator Embalagem"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="4.000"
                    id="titulo"
                    label="Total Embalagens"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="75px"></CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="01/09/2025"
                    id="titulo"
                    label="Prazo Final"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="09/08/2025"
                    id="titulo"
                    label="Data 1ª Entrega"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="150px">
                  <Input
                    name="titulo"
                    value="24/08/2025"
                    id="titulo"
                    label="Data Última Entrega"
                    onChange={handleChange}
                    style={{ textAlign: 'right' }}
                    readonly
                  />
                </CustomCol>
                <CustomCol></CustomCol>
              </CustomRow>
            </BoxConteudo>
            <BoxConteudo boxTitulo="Entregas">
              <CustomRow>
                <CustomCol width="100%">
                  <Tabela
                    headers={headersContratosEntregaItem}
                    dataTable={tableEntregaItem}
                    displayValues={
                      valoresExibidosOffCanvasContratosTermoAditivo
                    }
                    onRowClick={handleRowClickEntrega}
                    dataOffCanvas={tableEntregaItem}
                    botaoAbrirOffCanvas={false}
                    showPagination={false}
                    noOffCanvasTable={true}
                  />
                </CustomCol>
              </CustomRow>
              <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
                <CustomButton
                  label="Nova Entrega"
                  bgColor={theme.colors.botaoAcao.azul}
                  textColor={theme.colors.white}
                  onClick={() => {
                    handleShowModalEntregaItem();
                  }}
                  // disabled={fichaID == 'undefined' ? true : false}
                />
              </CustomCol>

              <CustomOffcanvas
                title="Entrega de Item de Pauta"
                show={showModalEntregaItem}
                onClose={handleShowModalEntregaItem}
                width="70vw"
                // modalSize="medio"
              >
                <WorkspaceFicha>
                  <Log {...logEntregaItemData} />
                  <BoxConteudo boxTitulo="Identificação da Entrega">
                    <CustomRow
                      style={{
                        marginTop: '-15px',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <CustomCol width="200px">
                        <Input
                          name="dataVersao"
                          label="Data da Entrega"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                          type="date"
                        />
                      </CustomCol>
                      <CustomCol width="250px">
                        <Input
                          name="dataVersao"
                          label="Total Entregue"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                          type="number"
                          textAlign="right"
                        />
                      </CustomCol>
                      <CustomCol width="150px">
                        <Input
                          name="dataVersao"
                          label="% do Item da Pauta"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                          type="number"
                          textAlign="right"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol width="250px">
                        <Input
                          name="dataVersao"
                          label="Nota Fiscal"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                        />
                      </CustomCol>
                      <CustomCol width="250px">
                        <Input
                          name="dataVersao"
                          label="Valor da Nota Fiscal R$"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                          type="number"
                          textAlign="right"
                        />
                      </CustomCol>
                      <CustomCol width="250px">
                        <Input
                          name="dataVersao"
                          label="Status"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                          type="number"
                          readonly
                        />
                      </CustomCol>
                      <CustomCol></CustomCol>
                    </CustomRow>
                    <CustomRow>
                      <CustomCol>
                        <Input
                          name="dataVersao"
                          label="Histórico da Entrega"
                          value=""
                          id="dataVersao"
                          onChange={handleChange}
                          type="textarea"
                          linhas={5}
                        />
                      </CustomCol>
                    </CustomRow>
                  </BoxConteudo>
                  {/* <BoxConteudo boxTitulo="Observações Gerais" fechado>
                    <CustomRow>
                      <Col>
                        <Input
                          id="observacoes"
                          type="textarea"
                          name="observacoes"
                          value={formDestaque.observacoes}
                          linhas={3}
                          onChange={handleChange}
                        />
                      </Col>
                    </CustomRow>
                  </BoxConteudo> */}

                  <BarraInferiorBotoes>
                    <WorkspaceBotoes
                      inserir
                      // onClickInserir={handleChange}
                      inserirDisabled={fichaID == 'undefined' ? true : false}
                    />
                  </BarraInferiorBotoes>
                </WorkspaceFicha>
              </CustomOffcanvas>
            </BoxConteudo>

            <BoxConteudo boxTitulo="Observações Gerais" fechado>
              <CustomRow>
                <Col>
                  <Input
                    id="observacoes"
                    type="textarea"
                    name="observacoes"
                    value={formDestaque.observacoes}
                    linhas={3}
                    onChange={handleChange}
                  />
                </Col>
              </CustomRow>
            </BoxConteudo>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  onClickDelete={handleDelete}
                  save
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes inserir onClickInserir={handleCreate} />
              )}
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </CustomOffcanvas>

        <Tabela
          dataTable={tableEntrega}
          headers={headersContratosEntregas}
          displayValues={valoresExibidosProaq}
          dataOffCanvas={offCanvasData}
          onRowClick={handleRowClick}
          botaoAbrirOffCanvas={false}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidosProaq,
              fieldObjectProaq,
              'sisaf_proaq_destaques.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserirNovo}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ContratosEntregas;
